<template>
    <div class="quick-reply-message-viewer">
        <div
            :style="{
                ...messageColors,
                backgroundColor: determineColor(message),
                ...(extendedStyle || {}),
            }"
            class="sc-message--text"
        >
            <div style="border-radius: 6px">
                <div style="display: flex; flex-direction: column">
                    <span
                        class="sc-message--text-content m-1 ml-3 mr-3"
                        style="word-break: break-word; word-break: break-word"
                        v-html="data.message"
                    ></span>
                </div>

                <div
                    style="
                        display: flex;
                        flex-direction: row;
                        justify-content: end;
                        align-items: center;
                        padding: 0 0.3rem;
                    "
                >
                    <span v-if="meta" :style="{ color: messageColors.color }" class="sc-message-meta-new">{{
                        metaShorter(meta)
                    }}</span>
                    <span v-if="meta2" :style="{ color: messageColors.color }" class="sc-message--meta2">{{
                        meta2
                    }}</span>
                </div>
            </div>
        </div>
        <div class="quick-replies" v-if="!clickedButton">
            <div
                class="quick-reply"
                v-for="(button, i) in data.buttons"
                :key="button.id"
                @click="
                    sendButtonMessage('QUICK_REPLY', {
                        buttonId: button.id,
                        blockId: data.blockId,
                        payloadId: data.id,
                        buttonPayload: button.payload,
                    })
                "
            >
                <div class="quick-reply-text" v-html="button.title" />
            </div>
        </div>
    </div>
</template>

<script>
import _ from "lodash";
import { sendSocketMessage } from "../../../../utils/socketStream";
import { mapState } from "vuex";
import log2 from "../../../../utils/log2";

const log = log2("BotQuickReplyMessage");
export default {
    name: "BotQuickReplyMessage",
    props: {
        message: {
            type: Object,
            required: true,
        },
        data: {
            type: Object,
            required: true,
            default: () => ({
                buttons: [],
                message: "",
                id: "",
                blockId: "",
            }),
        },
        conversationId: {
            type: String,
            required: true,
        },
        messageColors: {
            type: Object,
            required: true,
        },
        extendedStyle: {
            type: Object,
        },
        isColored: {
            type: Boolean,
            default: false,
            required: false,
        },
        meta: {
            type: String,
            default: "",
            required: false,
        },
        meta2: {
            type: String,
            default: "",
            required: false,
        },
    },
    computed: {
        ...mapState({
            siteId: (state) => _.get(state.site.site, "_id"),
        }),
        isReadOnly() {
            return !this.conversationId.startsWith("test-");
        },
    },
    data() {
        return {
            clickedButton: false,
        };
    },
    methods: {
        sendButtonMessage(type, payload) {
            if (this.isReadOnly) return;
            this.clickedButton = true;
            const command = this.conversationId.startsWith("test-")
                ? "chatbot/v2 test-user-button-select"
                : "chatbot/v2 user-button-select";
            sendSocketMessage(command, {
                siteId: this.siteId,
                conversationId: this.conversationId,
                type,
                payload,
            });
        },
        metaShorter(text) {
            let delimiter = " - ";
            let t = text.split(delimiter);
            if (t[0].length > 11) t[0] = t[0].slice(0, 11) + "..";
            return t.join(delimiter);
        },
        determineColor(message) {
            log("determineColor", message);
            const name = message.author;
            const isRight = message.position === "right";
            let color = ";";
            if (isRight && this.isColored && this.userName !== name) {
                let hash = this.hashCode(name);
                let index = hash % this.colors.length;
                color = this.colors[index];
            } else if (this.isColored && this.userName === name) {
                color = "#4e8cff";
            } else if (!this.isColored && !isRight) {
                color = "#EAEAEA";
            } else {
                color = "";
            }

            return color;
        },
    },
};
</script>

<style lang="scss" scoped>
.quick-reply-message-viewer {
    .sc-message--text {
        width: 100% !important;
        max-width: 100% !important;
    }

    .msg {
        width: 100%;
        height: 100%;
        border-radius: 12px;
        padding: 6px 12px;
        background-color: #ffffff;
        position: relative;
    }

    .quick-replies {
        display: flex;
        flex-wrap: wrap;
        margin: 6px -5px 0;
        width: 100%;

        .quick-reply {
            background: #fff;
            border: 1px solid #006cff;
            border-radius: 16px;
            color: #006cff;
            cursor: pointer;
            font-size: 16px;
            font-weight: 600;
            min-height: 32px;
            height: auto;
            line-height: 30px;
            margin: 10px 5px 0;
            min-width: 100px;
            padding: 0 16px;
            position: relative;
            text-align: center;
            transition: all 0.3s;

            &:hover {
                .button-controls {
                    opacity: 1;
                }
            }

            .quick-reply-text {
                text-align: left;
                width: 100%;
            }
        }
    }
}
</style>
